"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDTH = void 0;
var react_1 = __importDefault(require("react"));
var classes_1 = __importDefault(require("@nerdwallet/base-styles/classes"));
exports.WIDTH = 6;
var Pointer = function () { return (react_1.default.createElement("svg", { className: (0, classes_1.default)("display-block"), width: exports.WIDTH, height: "9", viewBox: "0 0 6 9", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M2.99995 9L0.547172 3.902C-0.32226 2.09491 0.994595 0 2.99995 0C5.00531 0 6.32216 2.09491 5.45273 3.90199L2.99995 9Z", fill: "#006642" }))); };
exports.default = Pointer;
